<template>
  <div class="col-12 waitlist">
    <transition name="fade">
      <div v-if="waitlist.isLoading" class="loading">
        <span class="spinner-border spinner-border-sm" role="status"></span>
      </div>
    </transition>
    <div class="row">
      <div class="col-md-2">
        <span class="label larger">{{ waitlist.name }}</span>
        <span class="value">{{ getPrettyFloorplans(waitlist.floorplans) }}</span>
      </div>
      <div class="col-md-3">
        <StatusSelect :statuses="statuses" :status="getStatusObj(waitlist.status)" :id="waitlist.id" />
      </div>
      <div class="col-md-3">
        <span class="label">Email</span>
        <span class="value">{{ waitlist.email }}</span>
      </div>
      <div class="col-md-2">
        <span class="label">Phone</span>
        <span class="value">{{ waitlist.phone }}</span>
      </div>
      <div class="col-md-2 button-col">
        <button class="btn btn-red-outline" v-on:click="() => { openNotes(waitlist.id) }">Notes</button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusSelect from "./StatusSelect.vue";

export default {
  name: 'WaitlistItem',
  props: ['waitlist', 'statuses', 'openNotes'],
  methods: {
    getPrettyFloorplans: function (floorplans) {
      return "Floorplan" + (floorplans.length > 1 ? "s" : "") + " " + floorplans.join(", ");
    },
    getStatusObj: function (statusValue) {
      for (let i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i].value === statusValue) {
          return this.statuses[i];
        }
      }
      return false;
    },
  },
  components: {
    StatusSelect,
  }
}
</script>

<style lang="scss" scoped>
div.waitlist {
  background: #FFFFFF;
  border: 1px solid #ECECEC;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
  border-radius: 4px;
  padding-top: 25px;
  padding-bottom: 25px;
  margin-bottom: 1rem;
  position: relative;

  div.loading {
    position: absolute;
    z-index: 6;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(#4A4A4A, 0.33);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  span.label {
    display: block;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 2;
    color: #222222;

    &.larger {
      font-size: 1rem;
      line-height: calc(19/16);
    }
  }

  span.value {
    display: block;
    color: rgba(#222222, 0.56);
    font-size: 0.875rem;
    line-height: calc(24/14);
  }

  div.button-col {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 250ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
